import store from "../store";
import { formatPrintContent, print } from "./print";
export default class PrintPreviewContext {
  constructor(images) {
    this.images = images;

    this.displayHeader = false;
    this.pageLayout = "portrait";
    this.currentPage = 1;
    this.sheetNum = 0;
    this.imageNum = 0;
    this.isPrinting = false;

    this.imagesPerSheet = 1;
    if (this.images.length > 9)
      this.imagesPerSheet = 16;
    else if (this.images.length > 4)
      this.imagesPerSheet = 9;
    else if (this.images.length > 1)
      this.imagesPerSheet = 4;
  }

  refreshImages() {
    return store.dispatch("loadImages_full", this.images);
  }

  print() {
    let html = document.getElementById("printBody").innerHTML;
    let content = formatPrintContent(html, this.displayHeader, this.pageLayout, this.imagesPerSheet);
    return print(content);
  }

  getExSrNo() {
    if (!store.getters.exSrNo)
      return this.images[0].exSrNo;
    return store.getters.exSrNo;
  }

  getPtSrNo() {
    return store.getters.ptSrNo;
  }
}